var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('LayoutHead',{ref:"layoutHead",on:{"handleSearch":_vm.handleSearch}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{ref:"homeView"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{ref:"homeView"}):_vm._e(),_c('LayoutFoot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }